import React from "react";

import styles from "components/BudgetBuilder/Overview/OverviewLineItemsList/styles.css";
import { useTenantFormatter } from "components/BudgetBuilder/shared/TenantFormatter";
import Table from "components/Table";
import { formatNumberAsPercent, getPeriodSubtotal } from "utils/budgetBuilder";


const OverviewResearchTeamMemberRow = ({ items, index }) => {
	const { currencyFormatter } = useTenantFormatter();

	return (
		<Table.Row>
			<Table.Cell className={styles.cellAlignLeft}>
				<span>{items[0]?.name || "Unnamed Member"}</span>
			</Table.Cell>
			{items
				.map(member => member?.sponsoredCosts)
				.map((item, p) => (
					<Table.Cell key={`period-${index}-${p}`}>
						<div className={styles.cellAlignSpread}>
							<span>{formatNumberAsPercent(item?.effort, "")}</span>
							<span>{currencyFormatter(item?.reqSalary + item?.fringeRequested, "")}</span>
						</div>
					</Table.Cell>
				))}
			<Table.Cell className={styles.cellAlignRight}>
				<span className={styles.bold}>
					{currencyFormatter(getPeriodSubtotal(items, false))}
				</span>
			</Table.Cell>
		</Table.Row>
	);
};

export default OverviewResearchTeamMemberRow;
